/**
 * This module exports an enumeration `LanguageType` that describes the language version of the app.
 */
export enum LanguageType {
  en = 'en',
  es = 'es',
}
